<template>
  <div class="main-space">
    <ReviewsContainer
      :reviews-data="reviews"
      :title="title"
      :subtitle="subtitle"
      @view="handleView"
      @click="handleClick"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@experience/i18n';
import { ReviewsContainer } from '@experience/reviews-container';
import { ref, onMounted } from 'vue';

import ru from '@/features/reviewsContainer/i18n/ru';
import { getReviewsList } from '@/shared/api/generated/api';
import { useAnalytics } from '@/shared/lib/analytics';

type MessageSchema = typeof ru;
const { t } = useI18n<{ message: MessageSchema }, 'ru'>({
  inheritLocale: true,
  messages: { ru },
});

const { trackEvent, trackEventImmediately } = useAnalytics();

// Извлекаем тип RawReviewSlide из пропа reviewsData компонента ReviewsContainer
type ReviewsContainerInstance = InstanceType<typeof ReviewsContainer>;
type ReviewsContainerProps = ReviewsContainerInstance['$props'];
type RawReviewSlide = NonNullable<ReviewsContainerProps['reviewsData']> extends (infer U)[] ? U : never;

const reviews = ref<RawReviewSlide[]>([]);

const title = ref(t('title'));
const subtitle = ref(t('subtitle'));

onMounted(() => {
  void fetchData();
});

const fetchData = async () => {
  const { data } = await getReviewsList();
  // API возвращает данные в формате snake_case, которые соответствуют RawReviewSlide
  reviews.value = (data?.results ?? []) as RawReviewSlide[];
};

const handleView = (params: { position: number; review_id: number; experience_id: number }) => {
  void trackEvent('main:reviews.view', params);
};

const handleClick = (params: { position: number; review_id: number; experience_id: number }) => {
  void trackEventImmediately('main:reviews.click', params);
};
</script>
